import { Snackbar } from 'reactApp/modules/snackbar/snackbar.constants';

export enum SnackbarTypes {
    success = 'success',
    failure = 'failure',
    time = 'time',
    warning = 'warning',
    loading = 'loading',
    protect = 'protect',
}

export interface SnackbarItem {
    id: string;
    type?: SnackbarTypes;
    title?: string;
    text?: string;
    closable?: boolean;
    closeTimeout?: number;
    disableCloseTimeout?: boolean;
    buttonText?: string;
    onButtonClick?: () => void;
    onClose?: () => void;
    onShow?: () => void;
}

export type SnackbarListType = Record<string, SnackbarItem> | Record<string, never>;

export interface State {
    list: SnackbarListType;
    bottomMargin?: number;
}

interface SnackbarShowAction {
    type: typeof Snackbar.SHOW;
    payload: SnackbarItem;
}

interface SnackbarHideAction {
    type: typeof Snackbar.HIDE;
    payload: string;
}

interface SnackbarSetBottomMarginAction {
    type: typeof Snackbar.SET_BOTTOM_MARGIN;
    payload: number;
}

export type SnackbarActionTypes = SnackbarShowAction | SnackbarHideAction | SnackbarSetBottomMarginAction;
